export default {"src":"/_next/static/media/highlightfreecourses.d5e32f28.svg","height":180,"width":284};